import React, { SVGProps } from 'react';

const SvgRain5 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M4.308 13C3.033 13 2 11.993 2 10.75c0-.828.77-2.078 2.308-3.75 1.538 1.672 2.307 2.922 2.307 3.75 0 1.243-1.033 2.25-2.307 2.25zm15.384 0c-1.274 0-2.307-1.007-2.307-2.25 0-.828.769-2.078 2.307-3.75C21.231 8.672 22 9.922 22 10.75c0 1.243-1.033 2.25-2.308 2.25zM8.308 20C7.033 20 6 18.993 6 17.75c0-.828.77-2.078 2.308-3.75 1.538 1.672 2.307 2.922 2.307 3.75 0 1.243-1.033 2.25-2.307 2.25zM16 20c-1.275 0-2.308-1.007-2.308-2.25 0-.828.77-2.078 2.308-3.75 1.538 1.672 2.308 2.922 2.308 3.75 0 1.243-1.033 2.25-2.308 2.25z'
					fill='currentColor'
					opacity={0.3}
				/>
				<path
					d='M12 13c1.275 0 2.308-1.007 2.308-2.25 0-.828-.77-2.078-2.308-3.75-1.538 1.672-2.308 2.922-2.308 3.75C9.692 11.993 10.725 13 12 13z'
					fill='currentColor'
				/>
			</g>
		</svg>
	);
};

export default SvgRain5;
